import Vue from "vue"
import _ from "lodash"
import axios from "axios"
import Waterfall from "vue-waterfall/lib/waterfall"
import WaterfallSlot from "vue-waterfall/lib/waterfall-slot"
import SlVueTree from "@/components/mixins/sl-vue-tree/sl-vue-tree.vue"
import { DeviceListAPI, DeviceGroupAPI, FavorateAPI, ApprovalsAPI, RemoteAPI, MyDevicesAPI, GetMgridAPI } from "@/api"
import { history } from "@/api/analystic"
import store from "@/api/store"
import { user } from "@/api/access"
import { getExt } from "@/api/util"
import Sidebar from "../mixins/sidebar"
import rm from "./remote"
import { LiveviewDialog } from "@/components/dialogs"
import WOLDialog from "@/components/dialogs/wol.vue"
import Sortable from "sortablejs"
import DeviceMemo from "../mixins/device-memo"
import { EventBus } from "../management/EventBus"
import DialogAccess from "./components/dialogAccess"
import {deviceGroupHashAPI} from '@/api/device-group'
import MdmAssignModal from "@/components/mdm/MdmAssignModal.vue"
import MdmDeviceMapModal from "@/components/mdm/MdmDeviceMapModal.vue"

const storeKey = `devices`
let lastViewMode = "normal"

const hasAttr = (o, a) => {
  for (let i = 0; i < a.length; i++) {
    let v = a[i]
    if (typeof o[v] !== "string") return false
  }
  return true
}

export default {
  name: "device-component",
  components: { Sidebar, Waterfall, WaterfallSlot, LiveviewDialog, WOLDialog, SlVueTree, DeviceMemo, DialogAccess, MdmAssignModal, MdmDeviceMapModal },
  watch: {
    $route: {
      handler: function(route) {
        this.fetchList()
        const pk = route.params.groupPk
        const treeApi = this.$refs.sideTree
        if (!treeApi) return
        treeApi.traverse(node => {
          if (node.data.pk === pk) {
            if (!node._isSelected) {
              if (!route.params.devicePk) {
                treeApi.select(node.path)
              }
              let path = _.clone(node.path)
              path.pop()

              while (path.length) {
                treeApi.traverse((node, model) => {
                  if (_.isEqual(node.path, path)) {
                    Vue.set(model, "isExpanded", true)
                    return false
                  }
                })
                path.pop()
              }
            }
            return false
          }
        })
      },
      immediate: true,
    },
    // 필터 변경 시 선택 초기화 (필터 해제 후 범위 밖 기기까지 삭제되는 경로를 구조적으로 차단)
    filters: {
      handler() {
        this.clearSelection()
      },
      deep: true,
    },
    // 목록이 새로 로드(재할당)될 때마다 리소스 즉시 1회 채움
    devicelist() {
      void this.pollResources()
    },
  },
  computed: {
    networkType() {
      return store.get("networkType")
    },
    // MDM이면 fields 전체, 아니면 mdmOnly 컬럼(CPU/MEM/DISK·구성) 제거.
    // MDM 여부는 각 컬럼 정의의 mdmOnly 플래그로 표기 → 별도 키 목록 중복 없음.
    visibleFields() {
      if (this.AppState.isMdm) return this.fields
      return this.fields.filter(f => !f.mdmOnly)
    },
    devices() {
      let result = this.devicelist
      if (this.$route.params.groupPk === "favorate") result = _.filter(this.devicelist, v => v.favorate)

      if (this.filters.value !== null && this.filters.value !== "") {
        result = _.filter(result, v => {
          let value = this.filters.value
          if (typeof value === "number") return v[this.filters.key.value] === value
          else {
            if (!v[this.filters.key.value]) return false
            return _.includes(v[this.filters.key.value].toUpperCase(), value.toUpperCase())
          }
        })
      }
      this.page.total = result.length
      const list = _.map(result, v => {
        // v.alive = 1
        v._rowVariant = "active"
        v._ext = getExt(v.dev_os_id)
        v.ip = `${v.s_pub_ip} (${v.s_pri_ip})`
        return v
      })
      return list
    },
    // 리스트뷰 b-table / 썸네일뷰 waterfall / 체크박스 로직(isCheckAll 등) 공유.
    // 정렬은 b-table 로컬 정렬(localeCompare + 숫자 비교)을 재현 — 두 경로 렌더 결과가 반드시 일치해야 함.
    // 일치 깨지면 "화면 12개 ≠ 체크박스가 보는 12개"가 돼 화면 밖 기기가 선택·삭제되는 사고 발생.
    // Service 레포 커밋 e24270d(2024-11-05) 포팅. bootstrap-vue 업그레이드 시 b-table sort 알고리즘 재검증 필수.
    devicesOnPage() {
      let result = this.devicelist

      if (this.$route.params.groupPk === "favorate") result = _.filter(this.devicelist, v => v.favorate)

      // b-table 로컬 정렬(defaultSortCompare) 재현 — null/undefined/false 정규화, 숫자는 수치 비교, 나머지는 localeCompare.
      // favorate(null|객체), dev_ver(null 가능) 등 타입 혼합 필드에서도 b-table과 결과 일치 보장.
      if (this.sortBy) {
        result = [...result].sort((a, b) => {
          let va = a[this.sortBy]
          let vb = b[this.sortBy]
          va = va === null || va === undefined || va === false ? '' : va
          vb = vb === null || vb === undefined || vb === false ? '' : vb
          if (typeof va === 'number' && typeof vb === 'number') {
            return this.sortDesc ? vb - va : va - vb
          }
          return this.sortDesc
            ? String(vb).localeCompare(String(va))
            : String(va).localeCompare(String(vb))
        })
      }

      if (this.filters.value !== null && this.filters.value !== "") {
        result = _.filter(result, v => {
          let value = this.filters.value
          if (typeof value === "number") return v[this.filters.key.value] === value
          if (!v[this.filters.key.value]) return false
          return _.includes(v[this.filters.key.value].toUpperCase(), value.toUpperCase())
        })
      }

      this.page.total = result.length
      let all = _.map(result, v => {
        v._rowVariant = "active"
        v._ext = getExt(v.dev_os_id)
        return v
      })
      let offset = this.page.per * (this.page.current - 1)
      let onPage = _.slice(all, offset, offset + this.page.per)
      return onPage
    },
    // 아이콘뷰 pagination에 따라 보여지는 원격기기
    devicesOnIconPage() {
      let result = this.devicelist
      if (this.$route.params.groupPk === "favorate") result = _.filter(this.devicelist, v => v.favorate)

      if (this.filters.value !== null && this.filters.value !== "") {
        result = _.filter(result, v => {
          let value = this.filters.value
          if (typeof value === "number") return v[this.filters.key.value] === value
          else return _.includes(v[this.filters.key.value].toUpperCase(), value.toUpperCase())
        })
      }
      // 온라인 상태인 원격기기 순으로 정렬
      result = _.sortBy(this.devicelist, v => !v.alive)

      this.page_icon.total = result.length
      let all = _.map(result, v => {
        v._rowVariant = "active"
        v._ext = getExt(v.dev_os_id)
        return v
      })
      let offset = this.page_icon.per * (this.page_icon.current - 1)
      let onPage = _.slice(all, offset, offset + this.page_icon.per)
      return onPage
    },
    isRemovableGroup() {
      if (!this.grouplist.length) return false
      let pk = this.$route.params.groupPk
      if (!pk) return false
      let group = _.find(this.grouplist, { pk })
      if (!group) return false
      return !group.flag_df_group
    },
    upperGroup() {
      const pk = this.$route.params.groupPk ? parseInt(this.$route.params.groupPk, 10) : null

      if (pk === null) return false
      let selectedGroup = _.find(this.grouplist, { pk })
      if (!selectedGroup) return false
      return selectedGroup.group_fk || false
    },
    childGroup() {
      const pk = this.$route.params.groupPk ? parseInt(this.$route.params.groupPk, 10) : null

      if (pk === null) return []
      return _.filter(this.grouplist, { group_fk: pk })
    },
    groupName() {
      let result = null
      let pk = Number(this.$route.params.groupPk)
      this.grouplist.forEach(v => {
        if (v.pk === pk) {
          result = v.name
        }
      })
      return result
    },
    groupDeviceCount() {
      let result = null
      let pk = Number(this.$route.params.groupPk)
      this.grouplist.forEach(v => {
        if (v.pk === pk) {
          result = v.deviceCount
        }
      })
      return result
    },
    // 선택된 기기 수 — selectedPks 크기 그대로
    selectedCount() {
      return this.selectedPks.size
    },
    // 현재 페이지 전체가 선택됐는지 — 헤더 체크박스 checked 상태 근거
    isCheckAll() {
      const page = this.devicesOnPage
      return page.length > 0 && page.every(d => this.selectedPks.has(d.pk))
    },
    // 현재 페이지 일부만 선택됐는지 — 헤더 체크박스 indeterminate(▣) 상태 근거
    isIndeterminate() {
      const page = this.devicesOnPage
      const inSet = page.filter(d => this.selectedPks.has(d.pk)).length
      return inSet > 0 && inSet < page.length
    },
  },
  created() {
    // view-mode-changed 이벤트. GNB 에서 토글 버튼을 통해 View 모드를 변경.
    EventBus.$on("view-mode-changed", mode => {
      this.viewMode = mode
    })
    // 내부망이면 무조건 normal 모드 (스토어 값 무시)
    const networkType = store.get("networkType") || ""
    if (networkType.indexOf('i') === 0) {
      this.viewMode = "normal"
    } else {
      this.viewMode = store.get("viewMode") || "normal"
    }
    document.addEventListener("click", e => this.handleMouseClick(e))
    window.addEventListener("keydown", e => {
      if (this.showMenu && e.key == "Escape") this.showMenu = false
    })

    this.checkFields()
  },
  mounted() {
    this.fetchGroup()
    this.timer = setInterval(() => {
      this.timestamp = new Date().getTime()
    }, 5000)

    // 하드웨어 리소스 폴링 (MDM 전용) — 15초 주기. beforeDestroy에서 정리.
    if (this.AppState.isMdm) {
      // void = 반환 프로미스 의도적 무시(fire-and-forget). 에러는 pollResources 내부에서 처리.
      this.resourceTimer = setInterval(() => void this.pollResources(), 15000)
    }

    this.AppState.$on("expanded-data", data => {
      if (!this.expandedList.includes(data)) {
        this.expandedList.push(data)
      } else {
        this.expandedList = this.expandedList.filter(v => v !== data)
      }
    })
    this.AppState.$on("device-list-reload", data => {
      this.fetchList()
    })
    this.AppState.$on("device-state-change", () => {
      this.$log.info('[DATA CHANGED]')
      this.fetchList()
    })
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.resourceTimer)
    this.AppState.$off("device-state-change")
    EventBus.$off('view-mode-changed');
  },
  data() {
    return {
      lang: this.$i18n.locale,
      nodes: [],
      groupNodes: [],
      groupNodesMoveList: [],
      timer: null,
      resourceTimer: null,
      timestamp: 0,
      viewMode: store.get("viewMode") || "normal",
      editModeCheckboxState: true,
      excelLoaded: false,
      isBusy: false,
      nodeTitle: null,
      sidebarTargetNode: {},
      wait: false,
      // 체크박스 선택 상태 — 단일 진실원천. pk 집합만 유지, 나머지는 computed로 파생
      selectedPks: new Set(),
      sortBy: "alive",
      sortDesc: true,
      isGroupHashSynced: false, // 웹 스토리지의 해쉬 일치 여부
      showTooltip: {},
      menuIndex: {
        remote: 0,
        transfer: 1,
        wol: 2,
        approve: 3,
        detail: 4,
        live: 5,
        edit: 6,
        process: 7,
        update: 8,
        restart: 9,
        delete: 10,
        reboot: 11,
        shutdown: 12,
      },
      // 모든 메뉴는 숨김으로(0) 초기화
      // 사용자 권한에 따라 1로 변경될 예정
      contextMenuItems: [
        {
          text: this.$t("remote.normal.title"),
          action: "remote",
          status: 0,
        },
        {
          text: this.$t("remote.transfer.title"),
          action: "transfer",
          status: 0,
        },
        {
          text: this.$t("remote.wol.title"),
          action: "wol",
          status: 0,
        },
        {
          text: this.$t("remote.approve.desc"),
          action: "approve",
          status: 0,
        },
        // 상세보기 메뉴는 모든 사용자에게 제공
        {
          text: this.$t("remote.detail.title"),
          action: "detail",
          status: 0,
        },
        {
          text: this.$t("remote.preview.title"),
          action: "live",
          status: 0,
        },
        {
          text: this.$t("list_of_process"),
          action: "process",
          status: 0,
        },
        {
          text: this.$t("permissions.CSUpdate"),
          action: "update",
          status: 0,
        },
        {
          text: this.$t("remote.restart.title"),
          action: "restart",
          status: 0,
        },
        {
          text: this.$t("remote.delete.title"),
          action: "delete",
          status: 0,
        },
        {
          text: this.$t("remote.reboot.title"),
          action: "reboot",
          status: 0,
        },
        {
          text: this.$t("remote.shutdown.title"),
          action: "shutdown",
          status: 0,
        },
      ],
      showMenu: false,
      showIconMenu: false,
      selectedItem: null,
      menuPosition: {},
      groupCount: {
        usage: 0,
        limit: null,
      },
      cardSize: {
        current: 1,
        sizes: [
          {
            lineGap: 240,
            minLineGap: 220,
            maxLineGap: 280,
            height: 246,
          },
          {
            lineGap: 300,
            minLineGap: 280,
            maxLineGap: 320,
            height: 200,
          },
          {
            lineGap: 440,
            minLineGap: 320,
            maxLineGap: 520,
            height: 200,
          },
          {
            lineGap: 580,
            minLineGap: 520,
            maxLineGap: 680,
            height: 200,
          },
        ],
      },
      fields: [
        {
          key: "checkbox",
          label: "",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
          thStyle: { minWidth: "60px" },
        },
        {
          key: "groups_flag",
          label: this.$t("multiple"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
          thStyle: { minWidth: "45px" },
        },
        {
          key: "groups",
          label: this.$t("group_info"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
          thStyle: { minWidth: "140px" },
        },
        {
          key: "alias",
          label: this.$t("columns.alias"),
          sortable: true,
          thStyle: { minWidth: "200px" },
        },
        {
          key: "actions",
          label: this.$t("columns.actions"),
          sortable: false,
          thStyle: { minWidth: "170px" },
        },
        {
          key: "alive",
          label: this.$t("columns.alive"),
          tdClass: "text-left",
          thClass: "text-left",
          sortable: true,
          thStyle: { minWidth: "100px" },
        },
        {
          key: "dev_ver",
          label: this.$t("version"),
          tdClass: "text-left",
          thClass: "text-left",
          sortable: true,
          thStyle: { minWidth: "110px" },
        },
        {
          key: "memo",
          label: this.$t("columns.memo"),
          sortable: false,
          thStyle: { minWidth: "200px" },
        },
        {
          // MDM 전용 — 하드웨어 리소스(CPU/MEM/DISK). 폴링으로 실시간 갱신.
          // 매 틱 값이 바뀌어 정렬 시 오클릭 유발 → sortable:false. mdmOnly로 비-MDM에서 숨김.
          key: "cpu_usage",
          label: "CPU",
          mdmOnly: true,
          tdClass: "text-center",
          thClass: "text-center",
          sortable: false,
          thStyle: { minWidth: "80px" },
        },
        {
          key: "memory_usage",
          label: "MEM",
          mdmOnly: true,
          tdClass: "text-center",
          thClass: "text-center",
          sortable: false,
          thStyle: { minWidth: "80px" },
        },
        {
          key: "disk_usage",
          label: "DISK",
          mdmOnly: true,
          tdClass: "text-center",
          thClass: "text-center",
          sortable: false,
          thStyle: { minWidth: "80px" },
        },
        {
          key: "dev_os_id",
          label: "O/S",
          tdClass: "text-left",
          thClass: "text-left",
          sortable: true,
          thStyle: { minWidth: "140px" },
        },
        {
          // MDM 전용 — 배정 구성명. mdmOnly로 비-MDM에서 숨김.
          key: "profile_name",
          label: this.$t("mdm_config"),
          mdmOnly: true,
          tdClass: "text-left",
          thClass: "text-left",
          sortable: true,
          thStyle: { minWidth: "160px" },
        },
        {
          key: "ip",
          label: "IP",
          tdClass: "text-left",
          thClass: "text-left",
          sortable: true,
          thStyle: { minWidth: "180px" },
        },
        {
          key: "favorate",
          label: this.$t("favorate"),
          tdClass: "text-center",
          thClass: "text-center",
          sortable: true,
          thStyle: { minWidth: "160px" },
        },
      ],
      page: {
        total: 0,
        current: 1,
        per: 12,
        perOptions: [
          { value: 12, text: "12" },
          { value: 24, text: "24" },
          { value: 36, text: "36" },
        ],
      },
      page_icon: {
        total: 0,
        current: 1,
        per: 12,
        perOptions: [
          { value: 12, text: "12" },
          { value: 24, text: "24" },
          { value: 36, text: "36" },
        ],
      },
      grouplist: [],
      groupLoad: false,
      devicelist: [],
      expandedList: [],
      filters: {
        val: "alias",
        key: { value: "alias", text: this.$t("device_name") },
        keyOptions: [
          { value: "alias", text: this.$t("device_name") },
          { value: "memo", text: this.$t("columns.memo") },
          { value: "ip", text: "IP" },
          { value: "alive", text: this.$t("status") },
          { value: "dev_os_id", text: this.$t("O/S") },
        ],
        value: null,
        osOptions: [
          { value: "", text: this.$t("total") },
          { value: 1, text: "Windows" },
          { value: 2, text: "Linux" },
          { value: 3, text: "MacOS" },
          { value: 4, text: "Android" },
        ],
        statusOptions: [
          { value: "", text: this.$t("total") },
          { value: 1, text: "Online" },
          { value: 0, text: "Offline" },
        ],
      },
      filterPreValue: null,
      licenseDialog: {
        show: false,
        summary: {},
        devices: {},
      },
      groupDialog: {
        show: false,
      },
      liveView: {
        show: false,
        source: null,
        alive: 0,
      },
      wol: {
        show: false,
        device: null,
      },
      access: {
        name: null,
        show: false,
        device: null,
      },
      agent: `${this.AppState.Path.download}/agent`,
      processData: [],
      process_fields: [
        { key: "name", label: this.$t("name") },
        { key: "cpu", label: "CPU " + this.$t("use_rate") },
        { key: "memory", label: "Memory " + this.$t("use_rate") },
      ],
      tableClass: "",

      showDuplication: false,
    }
  },
  methods: {
    fetchList() {
      while (this.groupLoad === false) {
        setTimeout(() => {
          this.fetchList()
        }, 100)
        return
      }
      this.$log.info("[LOAD DATA FROM SERVER]")
      this.isBusy = true
      let params = {
        by: this.sortBy,
        device_group_pk: this.$route.params.groupPk === "favorate" ? "all" : this.$route.params.groupPk,
        order: this.sortDesc ? "desc" : "asc",
        search_mode: "normal",
        network_type: this.networkType.indexOf("i") === 0 ? "internal" : "external",
      }

      if (this.$route.params.groupPk === "self") {
        axios.all([MyDevicesAPI.get("", { params }), FavorateAPI.get("")]).then(
          axios.spread((devices, favs) => {
            this.devicelist = _.map(devices.data.objects, v => {
              v.aliasNew = v.alias
              v.memoNew = v.memo
              v.favorate = null
              v.groups_flag = v.device_group_name.length > 0 ? 1 : 0
              
              if (v.device_group_name.length > 1) {
                v.groups = `${v.device_group_name[0]}`
              } else if (v.device_group_name.length === 1) {
                v.groups = v.device_group_name[0] // 1개면 그대로 표시
              } else {
                v.groups = "-" // 0개일 경우 예외 처리
              }
              
              return v
            })

            _.each(favs.data.objects, v => {
              let dev = _.find(this.devicelist, { pk: v.dev_pk })
              if (dev) dev.favorate = v
            })

            this.setNodes()
            this.calcLicense()
            this.isBusy = false
          }),
        )
      } else {
        axios.all([DeviceListAPI.get("", { params }), FavorateAPI.get("")]).then(
          axios.spread((devices, favs) => {
            this.devicelist = _.map(devices.data.objects, v => {
              v.aliasNew = v.alias
              v.memoNew = v.memo
              v.favorate = null
              v.groups_flag = v.device_group_name.length > 0 ? 1 : 0
              v.groups = v.device_group_name
              
              if (v.device_group_name.length > 1) {
                v.groups = `${v.device_group_name[0]}`
              } else if (v.device_group_name.length === 1) {
                v.groups = v.device_group_name[0] // 1개면 그대로 표시
              } else {
                v.groups = "-" // 0개일 경우 예외 처리
              }
              
              return v
            })

            _.each(favs.data.objects, v => {
              let dev = _.find(this.devicelist, { pk: v.dev_pk })
              if (dev) dev.favorate = v
            })

            this.setNodes()
            this.calcLicense()
            this.isBusy = false
          }),
        )
      }
    },
    fetchGroup() {
      const params = {
        network_type: this.networkType.indexOf("i") === 0 ? "internal" : "external",
      }
      
      deviceGroupHashAPI.get("", {params})
        .then(res => {
          let storedGroupHash = store.get('groupHash')
          let groupHash = res.data.objects
          
          if (storedGroupHash === groupHash) {
            this.isGroupHashSynced = true
            
            this.grouplist = store.get('groupList')
            this.groupLoad = true
            return
          }
          DeviceGroupAPI.get("", { params }).then(res => {
            const groupList = res.data.objects
            const fetchedGroupHash  = res.data.meta.hash
            
            // 해시 웹스토리지 저장
            store.set("groupHash", fetchedGroupHash)
            
            // 권한 필터링
            let groupTmp = this.groupPermFilter(groupList)
            
            groupTmp = _.sortBy(groupTmp, [
              o => {
                if (o.name === "ROOT") {
                  o.name = this.$t("reserved.ROOT")
                  return "0"
                }
                return o.name
              },
            ])
            
            // 리스트 웹스토리지 저장 또는 최신화
            store.set("groupList", groupTmp)
            
            this.grouplist = groupTmp
            this.groupLoad = true
            this.isGroupHashSynced = false
          })
        })
    },
    async downloadExcel() {
      this.excelLoaded = true
      try {
        const params = await this.fetchExcel()
        
        if (params === "excel_download_cancel") {
          this.excelLoaded = false
          return
        }
        
        const form = document.createElement("form")
        form.method = "post"
        form.action = "/download/excel.html" // /download/excel.html을 통해 DownloadExcelFileAPI호출
        form.target = "_blank"
        
        // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = "jsondata"
        input.value = JSON.stringify({ ...params, language: this.$i18n.locale })
        form.appendChild(input)
        
        // body에 폼 추가 및 제출 그 후 제거
        document.body.appendChild(form)
        form.submit()
        document.body.removeChild(form)
      } catch (error) {
        alert(error.message)
      } finally {
        this.excelLoaded = false
      }
    },

    async fetchExcel() {
      let params = {
        by: "device_name",
        device_group_pk: this.$route.params.groupPk === "favorate" ? "all" : this.$route.params.groupPk,
        order: "desc",
        search_mode: "normal",
        network_type: this.networkType.indexOf("i") === 0 ? "internal" : "external",
      }

      let list = null
      let excel_doc_title = ""

      if (this.$route.params.groupPk === "favorate") {
        // 즐겨찾기에서 엑셀 다운로드
        list = await DeviceListAPI.get("", { params })
        let list2 = await FavorateAPI.get("")
        if (list2.data.objects.length === 0) {
          alert(this.$t('toasts_message.no_data_to_download'))
          return "excel_download_cancel"
        }
        list = this.join_all_favorite(list.data.objects, list2.data.objects) //즐겨찾기 데이터와 조인
        excel_doc_title = `${this.$t('device_page.remote_device_list')}_${this.$t('favorate')}`
      } else if (this.$route.params.groupPk == "self") {
        // 본인이 등록한 에이전트에서 엑셀 다운로드
        list = await MyDevicesAPI.get("", { params })
        excel_doc_title = `${this.$t('device_page.remote_device_list')}_${this.$t('device_page.self_registration')}`
        list = list.data.objects
      } else {
        // 모든 에이전트에서 엑셀 다운로드 or 각 그룹별 엑셀 다운로드
        list = await DeviceListAPI.get("", { params })
        excel_doc_title = this.$t('device_page.remote_device_list')
        list = list.data.objects
      }

      const excelParams = list
      
      if (excelParams.length === 0) {
        throw new Error(this.$t('toasts_message.no_data_to_download') || 'No data to download.');
      }
      
      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams),
      }
      excelParams_for_download.pagename = "AgentList"
      excelParams_for_download.excel_doc_title = excel_doc_title
      return excelParams_for_download
    },
    join_all_favorite(A, B) {
      var filteredData = []
      for (var i = 0; i < A.length; i++) {
        var itemA = A[i]
        for (var j = 0; j < B.length; j++) {
          var itemB = B[j]
          if (itemA.pk === itemB.dev_pk) {
            filteredData.push(itemA)
            break
          }
        }
      }

      return filteredData
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale // 현재 언어 저장
      this.$i18n.locale = "ko"
      
      let output = []
      let dev_os_id = {
        "": this.$t("total"),
        "1": "Windows",
        "2": "Linux",
        "3": "MacOS",
        "4": "Android",
      }
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [this.$t('device_page.remote_device_group_name')]: input[index]["device_group_name"],
          [`${this.$t('remote_device')} ${this.$t('name')}`]: input[index]["alias"],
          [this.$t('status')]: input[index]["actions"],
          [this.$t('version')]: input[index]["dev_ver"],
          [this.$t('memo')]: input[index]["memo"],
          "O/S": dev_os_id[input[index]["dev_os_id"]],
          Pri_Ip: input[index]["s_pri_ip"],
          Pub_Ip: input[index]["s_pub_ip"],
          
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },

    imageLoaded({ target }) {
      let { width, height } = target
      if (width > height) {
        target.className = "w-100"
      } else {
        target.className = "h-100"
      }
    },
    imageError({ target }) {
      target.src = `${this.AppState.Path.image}/live/live_no_img.jpg`
    },
    setFavorate(dev) {
      if (dev.favorate) {
        FavorateAPI.delete("", { params: { favnum: dev.favorate.pk } }).then(resp => {
          dev.favorite = 0
          dev.favorate = null
        })
      } else {
        FavorateAPI.post("", { servernum: dev.pk }).then(resp => {
          dev.favorite = 1
          dev.favorate = resp.data.objects
        })
      }
    },
    getAlive(id) {
      return id === 1 ? "toggle-on" : "toggle-off"
    },
    getOS(id) {
      switch (id) {
        case 1:
          return "windows"
        default:
          return "windows"
      }
    },
    setFilterKey(opt) {
      this.filters.value = null
      this.filterPreValue = null
      this.filters.key = opt
    },
    setFilterKey2(value) {
      this.filters.value = null
      this.filterPreValue = null
      this.filters.key = _.find(this.filters.keyOptions, { value })
      this.$nextTick(() => {
        this.filterPreValue = ""
      })
    },
    setFilterValue() {
      this.filters.value = this.filterPreValue
    },
    // @@@
    setViewMode(mode) {
      if (!mode) {
        let params = {
          context: { path: "not_save_warning" },
          withoutInput: true,
          submit: {
            size: "sm",
            color: "danger",
            text: "off-editmode",
          },
        }
        this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
          if (key === "submit") {
            this.viewMode = lastViewMode
          }
        })
        return
      }
      if (mode !== "edit") lastViewMode = mode
      if (this.viewMode === "edit") {
        _.each(this.devicelist, v => {
          v._isSelected = false
        })
      }
      if (mode === "live" && !this.AppState.isCorporate) {
        this.AppState.$emit('show-block-dialog')
      }
      else this.viewMode = mode

      // 내부망이 아닐 때만 스토어에 저장
      const networkType = store.get("networkType") || ""
      if (networkType.indexOf('i') !== 0) {
        if (mode === "simple" || mode === "normal") {
          store.set("viewMode", mode)
        }
      }
      this.AppState.viewMode = this.viewMode
    },
    showLiveView(device) {
      this.liveView.alive = device.alive
      this.liveView.source = `${this.AppState.Path.live}/${device.guid}.${device._ext}?cache=${this.timestamp}`
      this.liveView.show = true
    },
    liveViewChange(value) {
      this.liveView.show = value
    },
    viewDetail(item) {
      // (item, index, event)
      if (this.networkType.indexOf('e') === 0) {
        this.$router.push({
          name: "device-detail",
          params: { devicePk: item.pk },
          query: this.$route.query,
        })
      }
    },
    showWOLList(dev) {
      this.wol.device = dev
      this.wol.show = true
    },
    groupDialogOpen() {
      this.groupDialog.show = true
    },
    // MDM 적용 상태
    applyStatusVariant(status) {
      return { applied: "success", pending: "warning", failed: "danger" }[status] || "secondary"
    },
    applyStatusText(status) {
      const key = { applied: "mdm_status_applied", pending: "mdm_status_pending", failed: "mdm_status_failed" }[status]
      return key ? this.$t(key) : status
    },
    // 구성 적용 모달 열기 (단건·일괄 공용) — MdmAssignModal 컴포넌트에 위임
    openAssign(targets) {
      this.$refs.assignModal.open(targets)
    },
    // 위치 지도 — 대상 pk 배열을 받아 초기 표시. 단건=[pk]·벌크=[pk...] 동일 경로
    openDeviceMap(pks) {
      this.$refs.deviceMap.open(this.devicelist, pks)
    },
    // 원격기기 하드웨어 리소스 폴링 — /devices/resources를 받아 목록에 pk 기준 in-place 병합.
    // devices()는 devicelist를 같은 참조로 필터/정렬만 하므로 devicelist에 $set하면 그대로 반영된다.
    async pollResources() {
      if (document.hidden) return // 탭 비가시 시 스킵
      if (!this.AppState.isMdm) return // MDM 전용 게이트
      try {
        const res = await DeviceListAPI.get("resources")
        const rows = (res.data && res.data.objects) || []
        const byPk = {}
        rows.forEach(r => (byPk[r.pk] = r))
        this.devicelist.forEach(d => {
          const r = byPk[d.pk]
          if (!r) return
          this.$set(d, "alive", r.alive) // ON/OFF 전환도 폴링 대상
          this.$set(d, "cpu_usage", r.cpu_usage)
          this.$set(d, "memory_usage", r.memory_usage)
          this.$set(d, "disk_usage", r.disk_usage)
        })
      } catch (e) {
        // 실패는 사용자에게 노출하지 않고 다음 틱 재시도에 위임 (지속 재시도로 자연 복구)
        this.$log.info("[RESOURCE POLL] " + e)
      }
    },
    // 사용률(%) → 색상 클래스. 임계치 warn 60·bad 90 (기획서 pct ok/warn/bad, 나중 숫자만 조정)
    usageClass(v) {
      if (v == null) return ""
      if (v >= 90) return "text-danger font-weight-bold"
      if (v >= 60) return "text-warning font-weight-bold"
      return "text-success"
    },
    // 기능 메뉴 "구성 적용" — 체크된 기기 대상
    openAssignSelected() {
      const targets = this.devicelist.filter(v => this.selectedPks.has(v.pk))
      this.openAssign(targets)
    },
    // 모달 적용 완료(applied emit) — 성공 기기 즉시 반영(pending) 후 목록 재로드
    onAssigned({ pks, profileName }) {
      const set = new Set(pks)
      this.devicelist.forEach(dev => {
        if (set.has(dev.pk)) {
          dev.profile_name = profileName
          dev.apply_status = "pending"
        }
      })
      this.clearSelection()
      this.fetchList()
    },
    openModal(name, device) {
      if (name === "restart" && device === null) {
        // 선택된 기기 1건 기반 단건 재시작 (selectedCount === 1 조건부 진입)
        const pk = this.selectedPks.values().next().value
        device = this.devicelist.find(v => v.pk === pk)
        if (!device) return
      }

      if (device.alive === 0) {
        let params = {
          title: "LinkMeMine",
          context: { path: "not_online_warning" },
        }
        this.AppState.$emit("show-message-dialog", params)
        return
      }

      const { isMobile, isApplication, os } = this.AppState
      if (isMobile && !isApplication && name === "remote") {
        let params = {
          context: {
            path: "mobile_store",
            args: { url: this.AppState.mobile[os] },
          },
        }
        return this.AppState.$emit("show-message-dialog", params)
      }

      const { ua } = this.AppState
      let descName = ua.os.name === "Mac OS" ? "desc_mac" : "desc"
      let params = {
        title: this.$t(`remote.${name}.title`),
        context: this.$t(`remote.${name}.${descName}`),
        sort: "device",
        buttons: [
          {
            size: "sm",
            color: "primary",
            text: this.$t("execute"),
            action: close => {
              const resp = rm[name](device)
              if (resp === false) {
                this.$awn.alert(this.$t('not_supported_os'))
              } else if (resp === 'mobile') {
                // pass
              }
              else {
                this.$awn.success(this.$t(`remote.${name}.${resp}`))
              }
              close()
            },
          },
        ],
      }

      if (name === "reboot" || name === "shutdown") {
        params.buttons[0].color = "danger"
      }

      if (!!process.env.VUE_APP_USE_ACTIVEX && ua.browser.name === "IE") {
        params.buttons.unshift({
          size: "sm",
          color: "secondary",
          text: this.$t("execute") + this.$t("program") + " " + this.$t("download"),
          action: close => {
            const noActiveX = true
            const resp = rm[name](device, noActiveX)
            if (resp === false) this.$awn.alert(this.$t("not_supported_os"))
            this.$awn.success(this.$t(`remote.${name}.${resp}`))
            close()
          },
        })
      }

      if (ua.os.name === "Mac OS" /*&& window.navigator.maxTouchPoints === 0*/) {
        params.buttons.unshift({
          size: "sm",
          color: "secondary",
          text: this.$t("program") + " " + this.$t("download"),
          action: () => {
            window.open(`${this.AppState.Path.download}/lmmviewer/LinkMeMine_Viewer_installer.zip?cache=200528_01`, "_blank")
          },
        })
      }

      //보안서약서
      if (name === "remote" && device.security_agreement) {
        let params = {
          title: "test",
        }
        this.AppState.$emit("show-security-dialog", params, (key, data) => {
          if (key == "submit") {
            let params = {
              title: this.$t(`remote.${name}.title`),
              context: this.$t(`remote.${name}.desc`),
              download: true,
              buttons: [
                {
                  size: "sm",
                  color: "primary",
                  text: this.$t("execute"),
                  action: close => {
                    const resp = rm[name](device)
                    if (resp === false) this.$awn.alert(this.$t("not_supported_os"))
                    this.$awn.success(this.$t(`remote.${name}.${resp}`))
                    close()
                  },
                },
              ],
            }
            this.AppState.$emit("show-action-dialog", params)
          }
        })
        return
      }
      
      // if (name === "remote" && device.accessComplate === undefined) {
      //   this.access.show = true
      //   this.access.name = name
      //   this.access.device = device
      //   return
      // }

      this.AppState.$emit("show-action-dialog", params)
    },
    accessComplate() {
      this.access.show = false
      const device = this.access.device
      device.accessComplate = true
      this.openModal(this.access.name, device)
    },
    warningModal(name, device) {
      const { ua } = this.AppState
      let params = {
        title: this.$t(`remote.${name}.title`),
        context: this.$t(`remote.${name}.desc`),
        sort: "device",
        buttons: [
          {
            size: "sm",
            color: "danger",
            text: this.$t("execute"),
            action: close => {
              const resp = rm[name](device)
              if (resp === false) this.$awn.alert(this.$t("not_supported_os"))
              else this.$awn.success(this.$t(`remote.${name}.${resp}`))
              close()
            },
          },
        ],
      }
      this.AppState.$emit("show-warning-dialog", params)
    },
    addGroup() {
      const companyKey = user().company_fk
      let group_fk = this.$route.params.groupPk
      let root_group_fk = null
      let group = null
      if (group_fk) {
        group_fk = parseInt(group_fk, 10)
        group = _.find(this.grouplist, { pk: group_fk })
        if (group) root_group_fk = _.find(this.grouplist, { pk: group_fk }).root_group_fk
        else group_fk = null
        if (!root_group_fk) root_group_fk = group_fk
      } else group_fk = null

      let params = {
        context: group_fk
          ? { title: this.$t("add-group-child"), path: "add_child_group", args: { name: group.name } }
          : { title: this.$t("add-group"), path: "add_root_group" },
        limit: 40,
        placeholder: "name",
        submit: {
          size: "sm",
          color: "primary",
          text: "create",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key === "submit") {
          let params = {
            name: data,
            flag_df_group: false,
            flag_confirm: false,
            group_fk,
            root_group_fk,
            company_fk: companyKey,
          }
          DeviceGroupAPI.post("", params).then(resp => {
            if (resp.data.objects.overlap) {
              this.$awn.alert(this.$t("duplication_group_name"))
            } else {
              const group = resp.data.objects
              this.grouplist.push(group)
              store.update("devices", ({ groups }) => {
                group.has_permission = true
                groups.push(group)
              })
              this.setNodes()
              this.$awn.success(this.$t("created_group"))
            }
          })
        }
      })
    },
    removeGroup() {
      let params = {
        context: { path: "confirm_delete_group" },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete_group" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key === "submit") {
          let pk = this.$route.params.groupPk
          DeviceGroupAPI.delete(`${pk}`).then(resp => {
            _.remove(this.grouplist, v => v.pk === pk)
            store.update("devices", ({ groups }) => {
              _.remove(groups, v => v.pk === pk)
            })
            this.$awn.success(this.$t("deleted_group"))
            this.setNodes()
            this.$nextTick(() => {
              this.$router.replace({ name: "device-root" })
            })
          })
        }
      })
    },
    setCardItemSize(type) {
      if (type === "smaller") {
        if (this.cardSize.current === 0) return
        this.cardSize.current--
      } else if (type === "bigger") {
        if (this.cardSize.current === this.cardSize.sizes.length - 1) return
        this.cardSize.current++
      }
    },
    backToParent() {
      const pk = this.$route.params.groupPk ? parseInt(this.$route.params.groupPk, 10) : null
      if (pk) {
        let selected = _.find(this.grouplist, { pk })
        if (selected.root_group_fk) this.$router.push({ query: { group: selected.group_fk } })
        else this.$router.push({ query: { group: null } })
      }
    },
    getFavorate() {
      FavorateAPI.get("").then(({ data }) => {
        this.$log.info("[LOAD FAVORATES]")
        let devs = _.cloneDeep(this.devicelist)
        _.each(devs, v => {
          v.favorate = null
        })
        _.each(data.objects, v => {
          let dev = _.find(devs, { pk: v.dev_pk })
          if (dev) dev.favorate = v
        })
        this.devicelist = devs
        // this.setNodes()
      })
    },
    groupPermFilter(groups) {
      let perm = _.filter(groups, { has_permission: true })

      const addParent = fk => {
        if (!fk) return
        let exist = _.find(perm, { pk: fk })
        if (exist) return
        let parent = _.find(groups, { pk: fk })
        if (!parent) {
          this.$log.error("[INVALID PARENT GROUP] " + fk)
          return
        }
        if (parent) perm.push(parent)
        if (parent.root_group_fk) addParent(parent.group_fk)
      }
      _.each(perm, v => {
        let fk = v.group_fk
        addParent(fk)
      })
      return perm
    },
    getProcessData(item) {
      DeviceListAPI.get(`${item.pk}`).then(resp => {
        let { objects } = resp.data
        if (hasAttr(objects, ["prcss_name", "prcss_cpu_usage", "prcss_memory_usage"])) {
          this.processData = _.map(
            _.zip(
              objects.prcss_name.split(";"),
              objects.prcss_cpu_usage.split(";").map(v => parseInt(v, 10)),
              objects.prcss_memory_usage.split(";").map(v => parseInt(v, 10)),
            ),
            values => _.zipObject(["name", "cpu", "memory"], values),
          )
        }
        objects.memory_uses = Math.round((objects.memory_usage / 100) * objects.memory_capacity)
        objects.hdd_uses = Math.round((objects.hdd_usage / 100) * objects.hdd_capacity)
        this.device = objects
      })
    },
    editDeviceName(dev) {
      if (dev === null) {
        // 선택된 기기 1건 기반 단건 이름 변경 (selectedCount === 1 조건부 진입 — 호출부 가드 전제)
        const pk = this.selectedPks.values().next().value
        dev = this.devicelist.find(v => v.pk === pk)
        if (!dev) return
      }
      var oldAlias = dev.alias
      let params = {
        context: {
          title: this.$t(`device_name_edit`),
          path: "device_name_desc",
          args: { alias: dev.alias },
        },
        value: dev.alias,
        placeholder: "columns.alias",
        limit: 30,
        submit: {
          size: "sm",
          color: "primary",
          text: this.$t('change'),
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, value) => {
        if (key === "submit") {
          if (oldAlias == value) {
            return this.AppState.$emit("show-message-dialog", { context: { path: "device_name_identical" } })
          }
          DeviceListAPI.put(dev.pk.toString(), { alias: value }).then(resp => {
            this.AppState.$emit("show-message-dialog", { context: { path: "device_name_confirm", args: { alias: oldAlias, value: value } } })
            dev.alias = value
            store.set(storeKey, {
              devices: this.devicelist,
              groups: this.grouplist,
              updatedAt: new Date().getTime(),
            })
          })
        }
      })
    },
    updateRow(dev) {
      if (dev.aliasNew) {
        DeviceListAPI.put(dev.pk.toString(), { alias: dev.aliasNew }).then(resp => {
          dev.alias = dev.aliasNew
          store.set(storeKey, {
            devices: this.devicelist,
            groups: this.grouplist,
            updatedAt: new Date().getTime(),
          })
        })
      }
      if (dev.memoNew) {
        DeviceListAPI.put(dev.pk.toString(), { memo: dev.memoNew }).then(resp => {
          dev.memo = dev.memoNew
          store.set(storeKey, {
            devices: this.devicelist,
            groups: this.grouplist,
            updatedAt: new Date().getTime(),
          })
        })
      }
    },
    removeDevice(requestType, dev) {
      let params = {
        context: {
          title: requestType === 'delete' ? this.$t("delete_device") : this.$t("device_logoff"),
          path: requestType === 'delete' ? "confirm_delete_device" : 'confirm_device_logoff',
          args: { name: dev.alias },
        },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "primary",
          text: requestType === 'delete' ? { path: "delete" } : { path: "submit" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        
        let historyParams = {
          act_name_id: requestType === 'delete' ? 13 : 14,
          act_type_id: 5,
          device_pk: dev.pk,
          member_pk: user().pk,
          new_value: dev.alias,
          old_value: dev.dev_os_id,
        }

        history.post("audit", historyParams)
        
        requestType === 'delete' ? rm.remove(dev) : rm.remove(dev, 'agent_logoff')
        
        let deleteAction = requestType === 'delete'
          ? DeviceListAPI.delete(`${dev.pk}`).then(() => {
            this.AppState.$emit("show-message-dialog", { context: { path: "deleted_device" } })
            this.AppState.$emit("device-state-change")
          })
          : Promise.resolve()
        deleteAction.then(() => {
          this.fetchList()
        })
      })
    },
    removeSelectedDevice() {
      // 현재 선택된 기기 (selectedPks 기준)
      let selects = this.devicelist.filter(v => this.selectedPks.has(v.pk))
      if (!selects.length) {
        this.$awn.warning(this.$t("no-selects"))
        return undefined
      }

      const total = selects.length
      let count = 0

      let params = {
        context: {
          title: this.$t("delete_device"),
          path: "confirm_delete_device",
          args: { name: selects.map(v => v.alias).join(", ") },
        },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, async (key, data) => {
        if (key !== "submit") return
        // 모든 DELETE 응답을 allSettled로 일괄 수거한 뒤 1회만 fetchList
        // - 부분 실패가 있어도 완주 보장 (기존 count === total 경로는 실패 시 fetchList 누락 위험)
        // - DELETE / PUT remoteControl 기기별 호출은 bulk-delete 후속 PR에서 정리
        await Promise.allSettled(
          selects.map(async dev => {
            rm.remove(dev)
            await DeviceListAPI.delete(`${dev.pk}`)
            this.$awn.success(this.$t("deleted_device_count", { count: ++count, total }))
          })
        )
        this.AppState.$emit("device-state-change")
        this.clearSelection()
        this.fetchList()
      })
    },
    setDevGroup() {
      const treeApi = this.$refs.treeView
      let selectNode = treeApi.getSelected()
      if (!selectNode.length) {
        this.$awn.warning(this.$t("please_select_group"))
        return undefined
      }
      let group = selectNode[0].data
      // 현재 선택된 기기 (selectedPks 기준)
      let selects = this.devicelist.filter(v => this.selectedPks.has(v.pk))
      if (!selects.length) {
        this.$awn.warning(this.$t("no-selects"))
        return undefined
      }

      // 이미 같은 그룹인 기기는 이동 대상에서 사전 제외 (API 호출 자체를 생략)
      const targets = selects.filter(v => group.pk != v.device_group_fk)
      if (!targets.length) {
        this.AppState.$emit("show-message-dialog", { context: { path: "identical_group" } })
        return undefined
      }

      // 병렬 호출 후 allSettled로 결과 일괄 수거 (응답 순서에 따른 경쟁 조건 소거)
      Promise.allSettled(
        targets.map(v => {
          const params = {
            request_type: "change_group",
            device_fk: v.pk,
            group_fk: group.pk,
            old_group_fk: v.device_group_fk,
            errorCheck: false,
          }
          return DeviceListAPI.post("", params)
            .then(resp => ({ ok: true, dev: v }))
            .catch(err => ({ ok: false, dev: v, err }))
        })
      ).then(results => {
        const settled = results.map(r => r.value)
        const successes = settled.filter(s => s.ok)
        const failures = settled.filter(s => !s.ok)

        // 성공 기기 상태 반영 + 건별 토스트
        successes.forEach(({ dev }) => {
          dev.device_group_fk = group.pk
          this.$awn.success(this.$t("moved_device", { device: dev.alias, group: group.name }))
        })

        // 부분 실패 알림 (중복 그룹 케이스만 기존 로직 유지, 그 외는 공용 에러 interceptor가 처리)
        failures.forEach(({ err }) => {
          if (err.response.data.objects.error === this.$t('device_page.remote_device_already_exists')) {
            this.AppState.$emit("show-message-dialog", { context: { path: "identical_group" } })
          }
        })

        this.groupDialog.show = false
        this.clearSelection()
        this.fetchGroup()
        this.fetchList()
      })
    },
    valueChange(key, value, data) {
      this.$log.debug(`[CHANGED KEY: ${key}, VALUE: ${value}, DATA: ${data}]`)

      DeviceListAPI.put(`${data.pk}`, { memo: value }).then(resp => {
        this.AppState.$emit("show-message-dialog", { context: { path: "updated_memo" } })
        data.memo = value
        const devpk = data.pk
        let pdev = _.find(this.devicelist, v => v.pk === devpk)
        pdev.memo = value
        pdev.memoNew = value
        store.update("devices", ({ devices }) => {
          let devn = _.find(devices, v => v.pk === devpk)
          devn.memo = value
          devn.memoNew = value
        })
      })
    },
    updateMemo(dev) {
      if (!this.AppState.perm.modifyInformation) return
      let params = {
        context: { path: "please_input_memo" },
        value: dev.memo,
        limit: 140,
        placeholder: this.$t("columns.memo"),
        textarea: true,
        nullable: true,
        submit: {
          size: "sm",
          color: "primary",
          text: "submit",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, value) => {
        if (key !== "submit") return
        DeviceListAPI.put(`${dev.pk}`, { memo: value }).then(resp => {
          this.AppState.$emit("show-message-dialog", { context: { path: "updated_memo" } })
          dev.memo = value
          const devpk = dev.pk
          let pdev = _.find(this.devicelist, v => v.pk === devpk)
          pdev.memo = value
          pdev.memoNew = value
          store.update("devices", ({ devices }) => {
            let devn = _.find(devices, v => v.pk === devpk)
            devn.memo = value
            devn.memoNew = value
          })
        })
      })
    },
    selectNode(node, ev) {
      if (!ev) return
      let { data } = node[0]
      if (node[0].isLeaf) return

      // 다른 그룹으로 이동할때 선택 상태 초기화
      this.clearSelection()

      if (data.pk) {
        if (this.$route.name === "deviceAll" && this.$route.params.groupPk === data.pk) return
        this.$router.push({ name: "deviceAll", params: { groupPk: data.pk } })
      } else {
        if (this.$route.name === "deviceAll" && !this.$route.params.groupPk) return
        this.$router.push({ name: "deviceAll" })
      }
      // }
    },
    onNodeDoubleClick(node, ev) {
      if (this.networkType.indexOf("internal") > -1) return
      if (!ev) return
      if (ev.target.tagName.toLowerCase() !== "div" && ev.target.tagName.toLowerCase() !== "span") return
      if (!node.isLeaf) return
      let { data } = node
      if (this.$route.name === "device-detail" && this.$route.params.devicePk === data.pk) return
      this.$router.push({ name: "device-detail", params: { devicePk: `${data.pk}` } })
    },
    dropNode(nodes, position, event) {
      let target = nodes[0]
      let dest = position.node
      let { placement } = position

      // @@@ 이것 때문에 사이드바 드래그앤드롭이 안되었음.
      // if (!target.data.has_permission) {
      //   this.$awn.warning(this.$t('no_perm_group'))
      //   return
      // }
      if (!target.data.pk) {
        this.$awn.warning(this.$t("moved_device_fail", { name: this.$t("all_device") }))
        return
      }
      if (target.data.flag_df_group) {
        this.$awn.warning(this.$t("moved_device_fail", { name: this.$t("reserved.ROOT") }))
        return
      }
      if (dest.isLeaf) {
        let params = {
          request_type: "change_group",
          device_fk: target.data.pk,
          group_fk: dest.data.device_group_fk,
          old_group_fk: target.data.device_group_fk,
          errorCheck: false,
        }

        if (params.group_fk === params.old_group_fk) return this.AppState.$emit("show-message-dialog", { context: { path: "identical_group" } })

        DeviceListAPI.post("", params).then(resp => {
          let index = _.findIndex(this.devicelist, { pk: target.data.pk })
          this.devicelist[index].device_group_fk = dest.data.device_group_fk
          this.$awn.success(this.$t("moved_device", { device: target.data.alias, group: dest.data.device_group_name }))
          store.set(storeKey, {
            devices: this.devicelist,
            groups: this.grouplist,
            updatedAt: new Date().getTime(),
          })
          if (!this.expandedList.includes(dest.data.device_group_fk)) {
            this.expandedList.push(dest.data.device_group_fk)
          }
          this.setNodes()
        })
        return
      }

      if (placement === "inside") {
        if (!dest.data.pk) {
          this.$awn.warning(this.$t("all_device_has_no_child"))
          return
        }
        if (target.isLeaf) {
          let params = {
            request_type: "change_group",
            device_fk: target.data.pk,
            group_fk: dest.data.pk,
            old_group_fk: target.data.device_group_fk,
            errorCheck: false,
          }

          if (params.group_fk === params.old_group_fk) {
            return this.AppState.$emit("show-message-dialog", { context: { path: "identical_group" } })
          }
          DeviceListAPI.post("", params).then(resp => {
            this.$awn.success(this.$t("moved_device", { device: target.data.alias, group: dest.data.name }))
            this.fetchGroup()
            this.fetchList()
            // this.setNodes()
          })
        } else {
          let index = _.findIndex(this.grouplist, { pk: target.data.pk })
          let params = {}

          if (this.grouplist[index].group_fk === dest.data.pk) {
            return this.AppState.$emit("show-message-dialog", { context: { path: "identical_group" } })
          }

          this.grouplist[index].group_fk = dest.data.pk
          params.group_fk = dest.data.pk

          if (dest.data.root_group_fk === null) params.root_group_fk = dest.data.pk
          else params.root_group_fk = dest.data.root_group_fk

          DeviceGroupAPI.put(`${target.data.pk}`, params).then(resp => {
            this.grouplist[index].group_fk = params.group_fk
            this.grouplist[index].root_group_fk = params.root_group_fk
            this.$awn.success(this.$t("moved_device", { device: target.data.name, group: dest.data.name }))
            this.fetchGroup()
            this.fetchList()
          })
        }
      } else {
        if (target.isLeaf && placement === "after") {
          let params = {
            request_type: "change_group",
            device_fk: target.data.pk,
            group_fk: dest.data.pk,
            old_group_fk: target.data.device_group_fk,
            errorCheck: false,
          }
          DeviceListAPI.post("", params).then(resp => {
            let index = _.findIndex(this.devicelist, { pk: target.data.pk })
            this.devicelist[index].device_group_fk = dest.data.pk
            this.$awn.success(this.$t("moved_device", { device: target.data.alias, group: dest.data.name }))
            this.fetchGroup()
            this.fetchList()
          })
        } else if (target.isLeaf && placement === "before") {
          event.preventDefault()
        } else {
          if (target.data.group_fk === dest.data.group_fk) {
            this.$awn.warning(this.$t("no_order_warning"))
            return
          }
          let params = {
            group_fk: dest.data.group_fk || -1,
            root_group_fk: dest.data.root_group_fk || -1,
          }
          DeviceGroupAPI.put(`${target.data.pk}`, params).then(resp => {
            let index = _.findIndex(this.grouplist, { pk: target.data.pk })
            this.grouplist[index].group_fk = dest.data.group_fk
            this.grouplist[index].root_group_fk = dest.data.root_group_fk
            this.$awn.success(this.$t("moved_device_by", { device: target.data.name, group: dest.data.name }))
            this.fetchGroup()
            this.fetchList()
          })
        }
      }
    },
    calcLicense() {
      if (process.env.VUE_APP_STANDALONE) {
        //
        return
      }
      
      const license = user().license
      if ((license.total.vol === 0 && this.devicelist.length === 0) || license.total.vol < this.devicelist.length) {
        this.licenseDialog.summary = {
          fields: [
            { key: "expDate", label: this.$t("expire_date"), thClass: "text-center", tdClass: "text-center" },
            { key: "expVol", label: this.$t("exceed_device_vol"), thClass: "text-center", tdClass: "text-center" },
            { key: "vol", label: this.$t("available_count"), thClass: "text-center", tdClass: "text-center" },
          ],
          items: [
            {
              vol: license.total.vol,
              expVol: this.devicelist.length - license.total.vol,
              expDate: license.total.lastestExpireDateString,
            },
          ],
        }
        this.licenseDialog.devices = {
          fields: [
            { key: "alias", label: this.$t("device_name") },
            { key: "device_group_name", label: this.$t("group") },
            { key: "last_connected_time", label: this.$t("columns.last_connected_time"), thClass: "text-center", tdClass: "text-center" },
            { key: "remove", label: this.$t("delete"), thClass: "text-center", tdClass: "text-center" },
          ],
        }
        this.licenseDialog.show = true
      }
    },
    setNodes() {
      let result = []
      let resultGroups = []
      let dpk = this.$route.params.devicePk ? parseInt(this.$route.params.devicePk, 10) : null
      let gpk = /\d+/.test(this.$route.params.groupPk) ? parseInt(this.$route.params.groupPk, 10) : this.$route.params.groupPk
      let selectedGroup = null

      let groups = _.map(this.grouplist, v => {
        if (gpk && gpk === v.pk) selectedGroup = v
        v.deviceCount = 0
        const isDefaultGroup = v.name === this.$t('reserved.ROOT')
        
        if (v.name === this.$t('reserved.ROOT')) {
          v.name = this.$t('device_page.default_group')
        }
        
        return {
          isLeaf: false,
          isExpanded: false,
          isDraggable: isDefaultGroup ? false : this.AppState.perm.isAdmin,
          isSelected: !dpk && gpk === v.pk,
          title: v.name,
          pk: v.pk,
          root_group_fk: v.root_group_fk,
          group_fk: v.group_fk,
          data: v,
        }
      })
      let onlyGroups = _.cloneDeep(groups)

      let devs = _.map(this.devicelist, v => {
        if (dpk === v.pk) {
          selectedGroup = _.find(this.grouplist, { pk: v.device_group_fk })
        }
        return {
          title: v.alias,
          isLeaf: true,
          isSelected: dpk === v.pk,
          isDraggable: this.AppState.perm.isAdmin,
          pk: v.pk,
          device_group_fk: v.device_group_fk,
          data: v,
        }
      })

      const setParent = ppk => {
        let g = _.find(groups, v => v.data.pk === ppk)
        if (!g) return
        let currentPk = Number(this.$route.params.groupPk)
        if (!this.expandedList.includes(currentPk) && !g.isSelected) {
          this.expandedList.push(currentPk)
        }
        if (!this.expandedList.includes(ppk) && !g.isSelected) {
          this.expandedList.push(ppk)
        }
        if (g.group_fk) setParent(g.data.group_fk)
      }

      if (selectedGroup) setParent(selectedGroup.group_fk || selectedGroup.pk)

      groups.forEach(v => {
        if (this.expandedList.includes(v.pk)) {
          v.isExpanded = true
        }
      })

      result = _.concat(_.filter(groups, { root_group_fk: null }), _.filter(devs, { device_group_fk: null }))
      // result = _.concat(_.filter(groups, { root_group_fk: null }))
      resultGroups = _.filter(onlyGroups, { root_group_fk: null })

      let treePath = []
      const search = (g, counter) => {
        _.each(g, v => {
          if (v.isLeaf || v.isDevice) return
          let scopedDev = _.filter(devs, { device_group_fk: v.pk })
          if (counter !== undefined) {
            if (v.data.root_group_fk === null) {
              treePath = [v]
              counter = 0
            } else {
              if (!treePath[counter]) treePath.push(v)
              else treePath[counter] = v
            }
            _.each(treePath, (v, i) => {
              if (i <= counter) {
                v.data.deviceCount += scopedDev.length
              }
            })
          }
          v.children = _.concat(_.filter(groups, { group_fk: v.pk }), scopedDev)
          search(v.children, counter + 1)
        })
      }
      search(result, 0)

      const searchOnlyGroup = g => {
        _.each(g, v => {
          v.children = _.filter(onlyGroups, { group_fk: v.pk })
          search(v.children)
        })
      }
      searchOnlyGroup(resultGroups)

      result.unshift({
        isLeaf: false,
        isExpanded: false,
        isSelected: gpk === "self",
        isDraggable: false,
        title: "user_registered_agent",
        pk: "self",
        data: { pk: "self", self: true, dummy: true },
      })

      result.unshift({
        isLeaf: false,
        isExpanded: false,
        isSelected: gpk === "favorate",
        isDraggable: false,
        title: "favorate",
        pk: "favorate",
        data: { pk: "favorate", favorate: true, dummy: true },
      })

      result.unshift({
        isLeaf: false,
        isExpanded: false,
        isSelected: gpk === "all",
        isDraggable: false,
        title: "all_device",
        pk: "all",
        data: { pk: "all", all: true, dummy: true },
      })

      this.nodes = result
      this.groupNodes = resultGroups

      function findNameByPk(pk, dataList) {
        const item = dataList.find(item => item.pk === pk)
        return item ? item.title : null
      }

      function buildFullNames(dataList) {
        return dataList.map(item => {
          let fullName = item.title
          let currentFk = item.group_fk

          while (currentFk) {
            const parentName = findNameByPk(currentFk, dataList)
            if (parentName) {
              fullName = parentName + " / " + fullName
              const parentItem = dataList.find(item => item.pk === currentFk)
              currentFk = parentItem ? parentItem.group_fk : null
            } else {
              break
            }
          }

          return {
            ...item,
            title: fullName,
          }
        })
      }
      this.groupNodesMoveList = _.filter(buildFullNames(onlyGroups), { data: { permission_flag: 1 } })
    },
    approvalStatus(ctx) {
      let params = {
        context: { path: "reset_n", args: { v: "OTP" } },
        submit: {
          size: "md",
          color: "primary",
          text: "registration",
          sort: "new",
        },
        alias: ctx.alias,
        device_pk: ctx.pk,
        s_pri_ip: ctx.s_pri_ip,
      }
      this.AppState.$emit("show-approval-request-dialog", params, (key, data) => {
        if (key === "submit") {
          let submitParams = {
            device_pk: ctx.pk,
            approver_pk: data.approver_pk,
            approver_name: data.approver_name,
            post_approval: data.post_approval,
            start_time: data.start_time,
            end_time: data.end_time,
            approval_reason: data.approval_reason,
            manager_device_pk: store.get("manager_device_pk") || null,
          }
          ApprovalsAPI.post("", submitParams)
            .then(resp => {
              this.$awn.success(this.$t("approval-success"))
            })
            .catch(err => {
              this.AppState.$emit("show-message-dialog", { context: { path: err.response.data.message } })
            })
        }
      })
    },
    updateAgent(device) {
      if (device === null) {
        // 선택된 기기 1건 기반 단건 에이전트 업데이트 (selectedCount === 1 조건부 진입 — 호출부 가드 전제)
        const pk = this.selectedPks.values().next().value
        device = this.devicelist.find(v => v.pk === pk)
        if (!device) return
      }
      let params = {
        context: {
          title: this.$t("permissions.CSUpdate"),
          path: "update_agent_desc",
          args: { current_ver: device.dev_ver, latest_ver: device.latest_ver },
        },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "primary",
          text: this.$t('update'),
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        RemoteAPI.put(`${device.guid}`, { type: "update" }).then(resp => {
          this.AppState.$emit("show-message-dialog", { context: { path: "update_agent_requested" } })
        })
      })
    },
    draggableTable(item, index, event) {
      if (this.sorTableDrag) {
        this.sorTableDrag.destroy()
      }
      const el = this.$refs.deviceTableBody
      this.sorTableDrag = this.createSortable(el, item, index)
    },
    thumbnailViewDrag($event, dev) {
      if (this.sorTableDrag) {
        this.sorTableDrag.destroy()
      }
      const thumbEl = $event.currentTarget
      this.sorTableDrag = this.createSortable(thumbEl.parentNode, dev)
    },
    createSortable(el, item) {
      let sortableEl = null

      // 리스트뷰와 썸네일뷰 관련 구분자
      if (el.$el !== undefined) {
        sortableEl = el.$el.querySelector(".lmm-table-body")
      } else {
        sortableEl = el
      }

      let childElement = null

      const dragenterHandler = e => {
        if (e.target !== this.sidebarDragTarget.$el) {
          childElement = e.target
          this.isTargetInside = true
        }
      }

      const dragleaveHandler = e => {
        // 드래그 중인 아이템이 해당 요소 밖으로 나갈 때
        if (!this.sidebarDragTarget.$el.contains(e.relatedTarget)) {
          this.isTargetInside = false
        }

        if (e.target.nodeName === "path" || e.target.nodeName === "svg") return

        // 마우스가 sl-vue-tree-nodes-list 밖으로 나갈 때
        if (e.relatedTarget && e.relatedTarget.classList.contains("sl-vue-tree-root")) {
          this.isTargetInside = false
        }
      }

      const dragoverHandler = e => {
        e.preventDefault()
      }

      const dropHandler = e => {
        if (this.isTargetInside) {
          if (e.target.className.includes("root")) return

          e.preventDefault()
          this.nodeTitle = e.target.textContent.replace(/\s*\([^)]*\)\s*/g, "")

          // 드래그해서 마우스 버튼을 뗄 때 해당 node 정보를 얻음
          // 모든장치, 즐겨찾기 관련 정보는 grouplist 배열에 없어서 nodeTitle 배열을 사용.
          if (this.nodeTitle === this.$t('device_page.all_devices') || this.nodeTitle === this.$t('favorate')) {
            if (this.nodeTitle === this.$t('device_page.all_devices')) this.nodeTitle = "all_device"
            if (this.nodeTitle === this.$t('favorate')) this.nodeTitle = "favorate"
            if (this.nodeTitle === this.$t('device_page.self_registered_remote_device')) this.nodeTitle = "self"
            let index = this.nodes.findIndex(e => e.title === this.nodeTitle)
            this.sidebarTargetNode = this.nodes[index]
          } else {
            let index = this.grouplist.findIndex(e => e.name === this.nodeTitle)
            this.sidebarTargetNode = this.grouplist[index]
          }
        }
      }

      return Sortable.create(sortableEl, {
        animation: 200,
        sort: false,
        onChoose: evt => {
          this.sidebarDragTarget = this.$refs.sideTree

          this.sidebarDragTarget.$el.addEventListener("dragenter", dragenterHandler)
          this.sidebarDragTarget.$el.addEventListener("dragleave", dragleaveHandler)
          this.sidebarDragTarget.$el.addEventListener("dragover", dragoverHandler)
          this.sidebarDragTarget.$el.addEventListener("drop", dropHandler, true)
        },
        onEnd: evt => {
          this.sidebarDragTarget.$el.removeEventListener("dragenter", dragenterHandler)
          this.sidebarDragTarget.$el.removeEventListener("dragleave", dragleaveHandler)
          this.sidebarDragTarget.$el.removeEventListener("dragover", dragoverHandler)
          this.sidebarDragTarget.$el.removeEventListener("drop", dropHandler, true)
          if (this.isTargetInside && this.sidebarTargetNode) {
            this.addDevToGroup(item, this.sidebarTargetNode)
            this.isTargetInside = false
          }
        },
      })
    },
    addDevToGroup(item, node) {
      let params = {
        device_pk: item.pk,
        new_device_group_fk: node.pk,
        old_device_group_fk: item.device_group_fk,
      }

      if (params.new_device_group_fk === params.old_device_group_fk) {
        return this.AppState.$emit("show-message-dialog", { context: { path: "identical_group" } })
      }

      if (this.nodeTitle === "all_device" || this.nodeTitle === "favorate" || this.nodeTitle === "self") {
        if (this.nodeTitle === "all_device" || this.nodeTitle === "self") return this.$awn.alert(this.$t('toasts_message.group_move_not_allowed'))

        if (this.nodeTitle === "favorate") {
          this.setFavorate(item)
          item.favorate !== null
            ? this.$awn.success(this.$t('device_page.device_favorite_removed'), {alias: item.alias})
            : this.$awn.success(this.$t('device_page.device_favorite_added'), {alias: item.alias})
          return
        }
      }
      DeviceListAPI.post("", params).then(resp => {
        let index = _.findIndex(this.devicelist, { pk: item.pk })
        this.devicelist[index].device_group_fk = node.pk
        this.devicelist[index].device_group_name = node.name
        store.update("devices", ({ devices }) => {
          devices[index].device_group_fk = node.pk
          devices[index].device_group_name = node.name
          this.$awn.success(this.$t('device_moved_to_group'), {alias: item.alias, name: node.name})
          if (!this.expandedList.includes(node.pk)) {
            this.expandedList.push(node.pk)
          }
          this.setNodes()
        })
      })
    },
    getGroupName() {
      let index = _.findIndex(this.grouplist, { pk: this.$route.params.groupPk })
      return this.grouplist[index].name
    },

    // 체크박스 단건 토글 — pk를 selectedPks에 add/remove. Set 재할당으로 Vue 반응성 보장
    togglePk(pk, checked) {
      const next = new Set(this.selectedPks)
      if (checked) next.add(pk)
      else next.delete(pk)
      this.selectedPks = next
    },
    // 헤더 체크박스 — 리스트뷰 현재 페이지 한정으로 전체 선택/해제
    selectAllRows(checked) {
      const pagePks = this.devicesOnPage.map(d => d.pk)
      const next = new Set(this.selectedPks)
      if (checked) pagePks.forEach(pk => next.add(pk))
      else pagePks.forEach(pk => next.delete(pk))
      this.selectedPks = next
    },
    // 선택 상태 전체 초기화 — 리셋 단일 진입점
    clearSelection() {
      this.selectedPks = new Set()
    },
    // 테이블 sort방식이 변경되었을 경우 초기화
    sortChange() {
      this.clearSelection()
    },
    // 아이콘뷰 우클릭 메뉴 옵션 구현
    showIconContextMenu(item) {
      this.selectedItem = item
      this.showIconMenu = true
      // 클릭 후 메뉴 x, y 좌표
      this.$nextTick(() => {
        const menu = document.querySelector(".rightClickMenuIcon")
        menu.style.top = `${event.pageY}px`
        menu.style.left = `${event.pageX}px`
      })

      // 온라인 & 제어권있음
      if (item.alive === 1 && item.approval === 1) {
        this.contextMenuItems[this.menuIndex.remote].status = 1
        this.contextMenuItems[this.menuIndex.wol].status = 0
        this.contextMenuItems[this.menuIndex.approve].status = 0
        this.contextMenuItems[this.menuIndex.live].status = 1
        this.contextMenuItems[this.menuIndex.update].status = 0
        this.contextMenuItems[this.menuIndex.restart].status = 1
        if (this.AppState.perm.CSFileManager && !item.disable_filetransfer) {
          this.contextMenuItems[this.menuIndex.transfer].status = 0
        }
        if (this.AppState.perm.useFunction) {
          this.contextMenuItems[this.menuIndex.delete].status = 1
          this.contextMenuItems[this.menuIndex.reboot].status = 1
          this.contextMenuItems[this.menuIndex.shutdown] && (this.contextMenuItems[this.menuIndex.shutdown].status = 1)
        }
      }

      // 온라인 & 제어권없음
      else if (item.alive === 1 && item.approval === 0) {
        this.contextMenuItems[this.menuIndex.remote].status = 0
        this.contextMenuItems[this.menuIndex.transfer].status = 0
        this.contextMenuItems[this.menuIndex.wol].status = 0
        this.contextMenuItems[this.menuIndex.approve].status = 1
        this.contextMenuItems[this.menuIndex.live].status = 0
        this.contextMenuItems[this.menuIndex.update].status = 0
        this.contextMenuItems[this.menuIndex.restart].status = 0
        this.contextMenuItems[this.menuIndex.delete].status = 0
        this.contextMenuItems[this.menuIndex.reboot].status = 0
        this.contextMenuItems[this.menuIndex.shutdown] && (this.contextMenuItems[this.menuIndex.shutdown].status = 0)
      }

      // 오프라인
      else if (item.alive === 0) {
        this.contextMenuItems[this.menuIndex.remote].status = 0
        this.contextMenuItems[this.menuIndex.transfer].status = 0
        this.contextMenuItems[this.menuIndex.approve].status = 0
        this.contextMenuItems[this.menuIndex.live].status = 0
        this.contextMenuItems[this.menuIndex.update].status = 0
        this.contextMenuItems[this.menuIndex.restart].status = 0
        this.contextMenuItems[this.menuIndex.reboot].status = 0
        this.contextMenuItems[this.menuIndex.shutdown] && (this.contextMenuItems[this.menuIndex.shutdown].status = 0)
        if (this.AppState.perm.useFunction) {
          this.contextMenuItems[this.menuIndex.delete].status = 1
        }
        if (this.AppState.isCorporate && this.AppState.perm.useFunction) {
          this.contextMenuItems[this.menuIndex.wol].status = 0
        }
      }
    },
    // 리스트뷰 우클릭 메뉴 옵션 구현
    showContextMenu(item, index, evt) {
      if (this.networkType.indexOf("i") === 0) return
      evt.preventDefault()
      this.selectedItem = item
      this.showMenu = true

      this.$nextTick(() => {
        const menu = document.querySelector(".rightClickMenu")
        menu.style.top = `${evt.pageY}px`
        menu.style.left = `${evt.pageX}px`
      })

      // 온라인 & 제어권있음
      if (item.alive === 1 && item.approval === 1) {
        this.contextMenuItems[this.menuIndex.remote].status = 1
        this.contextMenuItems[this.menuIndex.wol].status = 0
        this.contextMenuItems[this.menuIndex.approve].status = 0
        this.contextMenuItems[this.menuIndex.live].status = 1
        this.contextMenuItems[this.menuIndex.edit].status = 1
        this.contextMenuItems[this.menuIndex.restart].status = 1
        if (this.AppState.perm.useFunction) {
          this.contextMenuItems[this.menuIndex.delete].status = 1
          this.contextMenuItems[this.menuIndex.reboot].status = 1
          this.contextMenuItems[this.menuIndex.shutdown] && (this.contextMenuItems[this.menuIndex.shutdown].status = 1)
        }
      }

      // 온라인 & 제어권없음
      else if (item.alive === 1 && item.approval === 0) {
        this.contextMenuItems[this.menuIndex.remote].status = 0
        this.contextMenuItems[this.menuIndex.transfer].status = 0
        this.contextMenuItems[this.menuIndex.wol].status = 0
        this.contextMenuItems[this.menuIndex.approve].status = 1
        this.contextMenuItems[this.menuIndex.live].status = 0
        this.contextMenuItems[this.menuIndex.update].status = 0
        this.contextMenuItems[this.menuIndex.restart].status = 0
        this.contextMenuItems[this.menuIndex.delete].status = 0
        this.contextMenuItems[this.menuIndex.reboot].status = 0
        this.contextMenuItems[this.menuIndex.shutdown] && (this.contextMenuItems[this.menuIndex.shutdown].status = 0)
      }

      // 오프라인
      else if (item.alive === 0) {
        this.contextMenuItems[this.menuIndex.remote].status = 0
        this.contextMenuItems[this.menuIndex.transfer].status = 0
        this.contextMenuItems[this.menuIndex.approve].status = 0
        this.contextMenuItems[this.menuIndex.live].status = 0
        this.contextMenuItems[this.menuIndex.update].status = 0
        this.contextMenuItems[this.menuIndex.restart].status = 0
        this.contextMenuItems[this.menuIndex.reboot].status = 0
        this.contextMenuItems[this.menuIndex.shutdown] && (this.contextMenuItems[this.menuIndex.shutdown].status = 0)
        if (this.AppState.perm.useFunction) {
          this.contextMenuItems[this.menuIndex.delete].status = 1
        }
      } else {
        //
      }
    },
    // 리스트뷰, 아이콘뷰 우클릭 메뉴 함수
    handleContextMenu(action) {
      const item = this.selectedItem
      switch (action) {
        // 온라인 + 제어권있음 메뉴
        case "remote":
          this.openModal("remote", item)
          break
        case "transfer":
          this.openModal("transfer", item)
          break
        case "detail":
          this.viewDetail(item)
          break
        case "live":
          this.showLiveView(item)
          break
        case "edit":
          this.editDeviceName(item)
          break
        /* TODO 프로세스 목록 구현중
          case 'process':
          break;
        */
        case "update":
          this.updateAgent(item)
          break
        case "restart":
          this.openModal("restart", item)
          break
        case "delete":
          this.removeDevice(item)
          break
        case "reboot":
          this.openModal("reboot", item)
          break
        case "shutdown":
          this.openModal("shutdown", item)
          break
        case "approve":
          this.approvalStatus(item)
          break
        case "wol":
          this.showWOLList(item)
          break
      }
    },
    // 우클릭 후 row 밖을 클릭할 경우 우클릭 메뉴 숨김처리
    handleMouseClick(event) {
      this.showMenu = false
      this.showIconMenu = false
    },
    openDropDown() {
      this.tableClass = "show-dropdown"
    },
    closeDropDown() {
      this.tableClass = ""
    },

    // 내, 외부 field 체크
    checkFields() {
      let fields = _.cloneDeep(this.fields)
      if (this.networkType.indexOf("i") === 0) {
        fields = fields.filter(v => v.key !== "actions")
      } else {
        fields = fields.filter(v => v.key !== "checkbox")
      }
      this.fields = fields
    },
    showTooltipHandler(item, state) {
      if (item.device_group_fk.length <= 1) return
      this.$set(this.showTooltip, item.pk, state)
    },
    hideTooltipHandler() {
      this.showTooltip = {}
    },
    formattedGroupName(item) {
      return item.device_group_name
        ? item.device_group_name.slice().sort().join(', ')
        : 'No Group';
    }
  },
}